import { urls } from 'constants/urls';
import { delay, http, HttpResponse } from 'msw';

const addContact = [
  http.post(`${process.env.BFF_TRUCKER_PROFILE_URL}${urls.contactList.contact}`, async () => {
    await delay();
    return HttpResponse.json(null, { status: 200 });
  }),
];

const removeContact = [
  http.delete(`${process.env.BFF_TRUCKER_PROFILE_URL}${urls.contactList.contact}/:personUid`, async () => {
    await delay();
    return HttpResponse.json(null, { status: 200 });
  }),
];

const hasContactListFeature = [
  http.get(`${process.env.BFF_CONTACT_LIST_URL}check-feature-access`, async () => {
    await delay();
    return HttpResponse.json({ access: true }, { status: 200 });
  }),
];

export { addContact, hasContactListFeature, removeContact };
